import { Stack } from '@mui/material'
import { UserRole } from '@tnf-recruit/shared'
import { AppPageHeader } from '../components/AppPageHeader'
import { useUser } from '../hooks/useUser'
import { ProfileVisibilityCard } from '../components/settings/ProfileVisibilityCard'
import { AccountCard } from '../components/settings/AccountCard'
import { ChangePasswordCard } from '../components/settings/ChangePasswordCard'

export const SettingsPage = () => {
  const { data: dbUser } = useUser()
  const isStudent = dbUser?.role === UserRole.STUDENT

  return (
    <Stack spacing={3} sx={{ maxWidth: 760 }}>
      <AppPageHeader
        title="Account settings"
        description="Manage your visibility, account, and password."
      />
      {isStudent && <ProfileVisibilityCard />}
      <AccountCard />
      <ChangePasswordCard />
    </Stack>
  )
}
